import { Store } from '../types'

export const pagesSelector = (store: Store) => store.pages
